import { render } from "./AIShareCoach.vue?vue&type=template&id=413ab846&scoped=true&ts=true"
import script from "./AIShareCoach.vue?vue&type=script&lang=ts"
export * from "./AIShareCoach.vue?vue&type=script&lang=ts"

import "./AIShareCoach.vue?vue&type=style&index=0&id=413ab846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413ab846"]])

export default __exports__